module.exports = __webpack_public_path__ + "static/media/qualification.9ea8dace.svg";